import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_w4HPdob6HwVt: {
	id: 'prd_w4HPd2DEV2ob6HwVt'
	ident: 'prd_w4HPdob6HwVt'
	sku: 'simple_premium_4w_7_99_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_CZvFI2DEV2CGbJlSH'
			amount: 44
			amount_usd: 7.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 7.99
			discount: 36.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_AtKDZ2DEV20ddPX2O'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_w4HPdob6HwVt, SubscriptionProduct>
const prd_w4HPdob6HwVt = { ident: 'prd_w4HPdob6HwVt' } as typeof _prd_w4HPdob6HwVt

export default prd_w4HPdob6HwVt
